<div class="guidelines-config" [nbSpinner]="saving()">
  <div class="guidelines-grid">

    <!-- Clerk Guidelines -->
    <nb-card>
      <nb-card-header>
        <h6>Sachbearbeiter-Leitfaden</h6>
        @if (clerkGuidelines()) {
          <span class="badge">
            <nb-icon pack="eva" icon="checkmark-circle-2-outline" status="success"></nb-icon>
            Konfiguriert
          </span>
        }
      </nb-card-header>
      <nb-card-body>
        <div class="field-group">
          <label class="label">Infotext</label>
          <wr-rich-text-editor
            [ngModel]="clerkInfoText()"
            (ngModelChange)="clerkInfoText.set($event)"
            [disabled]="!canEdit()">
          </wr-rich-text-editor>
        </div>

        <div class="field-group">
          <label class="label">Checkliste</label>
          <div class="checklist-items">
            @for (item of clerkChecklistItems(); track $index) {
              <div class="checklist-item">
                <input nbInput
                       fullWidth
                       [value]="item"
                       (input)="updateClerkItem($index, $any($event.target).value)"
                       placeholder="Checklistenpunkt..."
                       [disabled]="!canEdit()">
                @if (canEdit()) {
                  <button nbButton ghost status="danger" size="small"
                          (click)="removeClerkItem($index)">
                    <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                  </button>
                }
              </div>
            }
          </div>
          @if (canEdit()) {
            <button nbButton size="small" status="primary" ghost
                    (click)="addClerkItem()">
              <nb-icon pack="eva" icon="plus-outline"></nb-icon>
              Punkt hinzufügen
            </button>
          }
        </div>
      </nb-card-body>
      @if (canEdit() && (clerkGuidelines() || clerkHasData())) {
        <nb-card-footer>
          <button nbButton status="danger" ghost (click)="clearClerk()" [disabled]="saving()">
            Löschen
          </button>
        </nb-card-footer>
      }
    </nb-card>

    <!-- Technician Guidelines -->
    <nb-card>
      <nb-card-header>
        <h6>Techniker-Leitfaden</h6>
        @if (technicianGuidelines()) {
          <span class="badge">
            <nb-icon pack="eva" icon="checkmark-circle-2-outline" status="success"></nb-icon>
            Konfiguriert
          </span>
        }
      </nb-card-header>
      <nb-card-body>
        <div class="field-group">
          <label class="label">Infotext</label>
          <wr-rich-text-editor
            [ngModel]="technicianInfoText()"
            (ngModelChange)="technicianInfoText.set($event)"
            [disabled]="!canEdit()">
          </wr-rich-text-editor>
        </div>

        <div class="field-group">
          <label class="label">Checkliste</label>
          <div class="checklist-items">
            @for (item of technicianChecklistItems(); track $index) {
              <div class="checklist-item">
                <input nbInput
                       fullWidth
                       [value]="item"
                       (input)="updateTechnicianItem($index, $any($event.target).value)"
                       placeholder="Checklistenpunkt..."
                       [disabled]="!canEdit()">
                @if (canEdit()) {
                  <button nbButton ghost status="danger" size="small"
                          (click)="removeTechnicianItem($index)">
                    <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                  </button>
                }
              </div>
            }
          </div>
          @if (canEdit()) {
            <button nbButton size="small" status="primary" ghost
                    (click)="addTechnicianItem()">
              <nb-icon pack="eva" icon="plus-outline"></nb-icon>
              Punkt hinzufügen
            </button>
          }
        </div>
      </nb-card-body>
      @if (canEdit() && (technicianGuidelines() || technicianHasData())) {
        <nb-card-footer>
          <button nbButton status="danger" ghost (click)="clearTechnician()" [disabled]="saving()">
            Löschen
          </button>
        </nb-card-footer>
      }
    </nb-card>

  </div>
</div>
